import { combineReducers } from 'redux';
import cartoReducer from './cartoReducer.js';

export default combineReducers({
    carto: cartoReducer
})